import { Point, Polygon, MultiPolygon, GeoJSONObject } from 'src/common-services/types/geojson-types'
import { z } from 'zod'
import { pointSchema } from 'src/common-services/types/util-types'

export enum ResultType {
  Venue = 'venue',
  Cluster = 'cluster',
  Address = 'address',
}

export enum VenueWeightMetric {
  LATEST_MONTHLY_VISITS = 'lmv',
}

export type NearestVenueRequest = NearestVenuePointRequest | NearestVenuePolygonRequest

export const nearestVenuePointRequestSchema = z.object({
  point: pointSchema,
  radiusMiles: z.number().gt(0).lt(10).optional(),
  maxNumber: z.number().gt(0).optional(),
})

export type NearestVenuePointRequest = z.infer<typeof nearestVenuePointRequestSchema>

export type NearestVenuePolygonRequest = {
  shape: Polygon | MultiPolygon
  weight?: VenueWeightMetric
  maxNumber?: number
}

export type NearVenue = {
  venueId: string
  name: string
  brand: string
  placeName: string
  placeId: string
  address: string
  point: Point
  naicsCode: string
  naicsLabel: string | null
  milesFrom?: number
  latestMonthlyVisits?: number
  zipCode: string
}

// the minimum amount of venue information we need to power map pins
export type MicroVenue = Pick<NearVenue, 'venueId' | 'brand' | 'placeId' | 'point' | 'latestMonthlyVisits'>

export type NearestVenueResponse = NearVenue[]

export type GetVenueByVenueIdRequest = { venueId: string }
export type GetVenueByPlaceIdRequest = { placeIds: string[] }

export type VenueDataResponse = {
  venueId: string
  trafficTrendsMonthly: boolean
  address: string
  areaId: string
  brandId: string
  brand: string
  city: string
  county: string
  naicsCode: string
  naicsLabel: string
  name: string
  state: string
  zipCode: string
  msaGeoid: string
  msaLabel: string
  msaType: string
  businessStatus: string
  formattedAddress: string
  icon: string
  latLng: GeoJSONObject
  placeName: string
  placeId: string
  types: string[]
}
